<template>
  <div class="common">
    <a-tabs v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" :status="item.status" :btns="item.btns" :cols="item.colums">
          </component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import cashingMain from "@/pages/review/cashing/cashing-main"
export default {
  components: {
    cashingMain
  },
  name: "pay",
  data() {
    return {
      tabData: [
        {
          name: "待复核",
          key: "review",
          comp: cashingMain,
          status: "0",
          btns: ["review"],
          colums: ["申请日期", "祺信编号", "担保方", "接收方", "持有方", "祺信面额(元)", "付款金额(元)", "到期日期", "变更状态", "经办员", "操作"]
        },
        {
          name: "复核记录",
          key: "records",
          comp: cashingMain,
          status: "1,2,3,4",
          colums: ["申请日期", "祺信编号", "担保方", "接收方", "持有方", "祺信面额(元)", "付款金额(元)", "到期日期", "变更状态", "经办员", "状态", "操作"]
        }
      ],
      tabCur: "review"
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/review/cashing/cashing.vue